import React, { useEffect, useState } from 'react';

const AdminWithdrawals = ({ token }) => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadData = () => {
        setLoading(true);
        fetch(`${import.meta.env.VITE_API_URL}/admin/withdrawals`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
        .then(res => res.json())
        .then(data => {
            setRequests(data);
            setLoading(false);
        })
        .catch(err => {
            console.error(err);
            setLoading(false);
        });
    };

    useEffect(() => { loadData(); }, []);

    // components/AdminWithdrawals.jsx

const handleAction = async (id, status) => {
    // কনফার্মেশন
    if (!confirm(`Are you sure you want to mark this request as ${status.toUpperCase()}?`)) return;
    
    try {
        const res = await fetch(`${import.meta.env.VITE_API_URL}/admin/withdrawals/${id}`, {
            method: 'PUT',
            headers: { 
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}` 
            },
            body: JSON.stringify({ status }) // 'completed' or 'rejected'
        });

        const data = await res.json();
        
        if (res.ok) {
            alert("Success: " + data.message);
            loadData(); // লিস্ট রিফ্রেশ
        } else {
            // এরর মেসেজটি দেখান
            alert("Error: " + data.message);
        }
    } catch (error) {
        console.error(error);
        alert("Network Error: Could not connect to server.");
    }
};

    return (
        <div className="bg-gray-800 rounded-xl border border-gray-700 overflow-hidden shadow-lg">
            <div className="p-6 border-b border-gray-700 flex justify-between items-center">
                <h3 className="text-xl font-bold text-white">💰 Withdrawal Requests</h3>
                <button onClick={loadData} className="text-sm text-blue-400 hover:text-blue-300">Refresh</button>
            </div>
            
            <div className="overflow-x-auto">
                <table className="w-full text-left text-sm text-gray-300">
                    <thead className="bg-gray-900/50 uppercase text-xs font-bold text-gray-500">
                        <tr>
                            <th className="p-4">Date</th>
                            <th className="p-4">Partner</th>
                            <th className="p-4">Amount</th>
                            <th className="p-4">Method Details</th>
                            <th className="p-4">Status</th>
                            <th className="p-4 text-right">Action</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-700">
                        {requests.map(req => (
                            <tr key={req.withdrawal_id} className="hover:bg-gray-700/30 transition">
                                <td className="p-4 text-gray-400">
                                    {new Date(req.requested_at).toLocaleDateString()}
                                </td>
                                <td className="p-4">
                                    <div className="font-bold text-white">{req.full_name}</div>
                                    <div className="text-xs text-gray-500">Wallet: ৳{req.wallet_balance}</div>
                                </td>
                                <td className="p-4 font-bold text-green-400 text-lg">৳{req.amount}</td>
                                <td className="p-4">
                                    <div className="font-bold text-indigo-300">{req.method}</div>
                                    <div className="text-xs font-mono bg-gray-900 px-2 py-1 rounded inline-block mt-1">
                                        {req.account_number}
                                    </div>
                                </td>
                                <td className="p-4">
                                    <span className={`px-2 py-1 rounded text-xs font-bold uppercase ${
                                        req.status === 'pending' ? 'bg-yellow-500/20 text-yellow-300 border border-yellow-500/30' : 
                                        req.status === 'completed' ? 'bg-green-500/20 text-green-300 border border-green-500/30' : 
                                        'bg-red-500/20 text-red-300 border border-red-500/30'
                                    }`}>
                                        {req.status}
                                    </span>
                                </td>
                                <td className="p-4 text-right space-x-2">
                                    {req.status === 'pending' && (
                                        <>
                                            <button 
                                                onClick={() => handleAction(req.withdrawal_id, 'completed')} 
                                                className="px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white rounded text-xs font-bold transition"
                                            >
                                                Approve
                                            </button>
                                            <button 
                                                onClick={() => handleAction(req.withdrawal_id, 'rejected')} 
                                                className="px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white rounded text-xs font-bold transition"
                                            >
                                                Reject
                                            </button>
                                        </>
                                    )}
                                    {req.status !== 'pending' && <span className="text-gray-600 text-xs italic">Processed</span>}
                                </td>
                            </tr>
                        ))}
                        {requests.length === 0 && !loading && (
                            <tr><td colSpan="6" className="p-8 text-center text-gray-500">No withdrawal requests found.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
export default AdminWithdrawals;